<template>
  <div>
    <br />
    <div align="center">
      <img src="../assets/images/logoa.png" style="height: 70px" alt="logoImg" />
    </div>
    <br />

    <div align="center" v-if="userTypeID == 11">
      <div class="Flex_Table" style="width: 90%">
        <div class="Flex_Row">
          <div class="Flex_Cell">
            <p>
              <b style="font-size: 18px; text-decoration: underline">
                INSTRUCTIONS FOR FILLING UP ONLINE APPLICATION FORM
              </b>
            </p>
          </div>
        </div>
        <div class="Flex_Row">
          <div
            class="Flex_Cell"
            style="
              border: solid 1px;
              margin-right: 5px;
              overflow: auto;
              height: calc(100vh - 280px);
              font-style: 12px;
            "
            align="center"
          >
            <div style="text-align: left">
              <ul style="margin-top: 10px">
                <li :class="chk1 == false ? 'instruction' : 'instructionAgree'">
                  <input type="checkbox" id="chk1" v-model="chk1" /><label
                    for="chk1"
                  >
                    Detailed instructions to fill up online application form
                    have been provided on the Dashboard under Icon ‘CANDIDATES
                    CORNER’ on website “https://aocrecruitment.gov.in” Candidates
                    are advised to read these instructions carefully before
                    filling up the online application form.</label
                  >
                </li>
                <li :class="chk2 == false ? 'instruction' : 'instructionAgree'">
                  <input type="checkbox" id="chk2" v-model="chk2" />
                  <label for="chk2"
                    >All fields are mandatory and will be filled up by the
                    Candidates as applicable.</label
                  >
                </li>
                <li :class="chk3 == false ? 'instruction' : 'instructionAgree'">
                  <input type="checkbox" id="chk3" v-model="chk3" />
                  <label for="chk3"
                    >Entries of candidate’s name, father/mother name, Date of
                    Birth, will be as given in the Matriculation or equivalent
                    certificate.</label
                  >
                </li>
                <li :class="chk4 == false ? 'instruction' : 'instructionAgree'">
                  <input type="checkbox" id="chk4" v-model="chk4" />
                  <label for="chk4"
                    >Entries for Caste, Category reservation, if applied for,
                    will be as given in the documents/certificates issued by the
                    competent authority.</label
                  >
                </li>
                <li :class="chk5 == false ? 'instruction' : 'instructionAgree'">
                  <input type="checkbox" id="chk5" v-model="chk5" />
                  <label for="chk5"
                    >Documents/Certificates as applicable to the post applied
                    for and the Caste, Category relaxation sought for, will be
                    uploaded in the “Uploading Documents” section of the online
                    application form. The size of the document will be as
                    specified. Candidates will ensure that the documents
                    uploaded are clear and legible.</label
                  >
                </li>
                <li :class="chk6 == false ? 'instruction' : 'instructionAgree'">
                  <input type="checkbox" id="chk6" v-model="chk6" />
                  <label for="chk6"
                    >Candidates will submit application form “ONLINE ONLY’. No
                    printout copy will be sent by post. Candidates may take a
                    printout of the application form for their future
                    reference.</label
                  >
                </li>
                <li :class="chk7 == false ? 'instruction' : 'instructionAgree'">
                  <input type="checkbox" id="chk7" v-model="chk7" />
                  <label for="chk7">
                    A candidate can apply for only one post in the current
                    advertisement. If a candidate is found to have applied for
                    more than one post with different credentials then his / her
                    candidature will be rejected.
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div align="center" v-if="userTypeID == 11">
      <input
        type="checkbox"
        id="chkIsAgree"
        v-model="chkAgree"
        v-on:change="Agree"
      />
      <label for="chkIsAgree" style="cursor: pointer">
        <span style="font-weight: bold; font-size: medium"
          >I hereby declare that I have read and understood the above mentioned
          instructions.</span
        ></label
      >

      <input
        type="button"
        id="btnAppForm"
        v-on:click="redirectToAppForm()"
        value="Agree and Continue to Fill Online Application Form"
        style="font-size: 18px; padding: 5px"
        title="Click here to redirect to application form"
      />
    </div>
    <div align="center" style="margin-top: 100px">
      <input
        type="button"
        id="btnSummaryForm"
        v-if="userTypeID == 1"
        v-on:click="redirectToSummaryForm()"
        value="Status Summary"
        style="font-size: 18px; padding: 5px"
        title="Click here to redirect Status Summary form"
      />
      <input
        type="button"
        id="btnUploadForm"
        v-if="(userTypeID != -1 && userTypeID != 11 && IsFileDriveRights)"
        v-on:click="redirectToUplodForm()"
        value="File Drive"
        style="font-size: 18px; padding: 5px"
      />
      <input
        type="button"
        id="btnDownloadStatusForm"
        v-if="(userTypeID != -1 && userTypeID != 11 && IsFileDriveRights)"
        v-on:click="redirectUploadDownloadStatusForm()"
        value="Upload Download Status"
        style="font-size: 18px; padding: 5px"
      />
    </div>
    <!--
      <h1>HOME PAGE</h1>
    -->
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import axios from "axios";
import config from "@/router/globalConfig";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      notices: [],
      circulars: [],
      userTypeID: -1,
      IsFileDriveRights:false,
      chk1: false,
      chk2: false,
      chk3: false,
      chk4: false,
      chk5: false,
      chk6: false,
      chk7: false,
      chk8: false,
      chk9: false,
      chk10: false,
      chkAgree: false,
    };
  },
  methods: {
    Agree() {
      if (this.chkAgree == true) {
        this.chk1 = true;
        this.chk2 = true;
        this.chk3 = true;
        this.chk4 = true;
        this.chk5 = true;
        this.chk6 = true;
        this.chk7 = true;
        this.chk8 = true;
        this.chk9 = true;
        this.chk10 = true;
      } else {
        this.chk1 = false;
        this.chk2 = false;
        this.chk3 = false;
        this.chk4 = false;
        this.chk5 = false;
        this.chk6 = false;
        this.chk7 = false;
        this.chk8 = false;
        this.chk9 = false;
        this.chk10 = false;
      }
    },
    getNotices() {
      const authToken = "bearer ".concat(
        window.sessionStorage.getItem("token")
      );
      const antiforgeryToken =
        window.sessionStorage.getItem("antiforgery_token");

      let NoticeID = -1;
      let IsActive = 1;
      let NoticeType = 1;
      let FromDate = new Date().addDays(-15).convertToString("dd/MMM/yyyy");
      let ToDate = new Date().addDays(15).convertToString("dd/MMM/yyyy");
      let Type = 1;
      axios
        .get(config.WEB_API_PATH + "Notice/GetNotice", {
          headers: {
            __RequestVerificationToken: antiforgeryToken,
            Authorization: authToken,
          },
          params: {
            NoticeID: NoticeID,
            IsActive: IsActive,
            NoticeType: NoticeType,
            FromDate: FromDate,
            ToDate: ToDate,
            Type: Type,
          },
          crossdomain: true,
        })
        .then(
          (result) => {
            this.notices = result.data;
          },
          (error) => {
            alert("Error: " + error);
          },
          (failure) => {
            alert("Failure: " + failure);
          }
        )
        .catch(function (error) {
          alert(error);
        });
    },
    getCirculars() {
      const authToken = "bearer ".concat(
        window.sessionStorage.getItem("token")
      );
      const antiforgeryToken =
        window.sessionStorage.getItem("antiforgery_token");

      let NoticeID = -1;
      let IsActive = 1;
      let NoticeType = 2;
      let FromDate = new Date().addDays(-15).convertToString("dd/MMM/yyyy");
      let ToDate = new Date().addDays(15).convertToString("dd/MMM/yyyy");
      let Type = 1;
      axios
        .get(config.WEB_API_PATH + "Notice/GetNotice", {
          headers: {
            __RequestVerificationToken: antiforgeryToken,
            Authorization: authToken,
          },
          params: {
            NoticeID: NoticeID,
            IsActive: IsActive,
            NoticeType: NoticeType,
            FromDate: FromDate,
            ToDate: ToDate,
            Type: Type,
          },
          crossdomain: true,
        })
        .then(
          (result) => {
            this.circulars = result.data;
          },
          (error) => {
            alert("Error: " + error);
          },
          (failure) => {
            alert("Failure: " + failure);
          }
        )
        .catch(function (error) {
          alert(error);
        });
    },
    getCandidateApp() {
      this.candApplication_List = [];
      const _data_ = { advtID: -1, type: 1 };
      axios
        .get(config.WEB_API_PATH + "Registration/GetCandApplication", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.candApplication_List = response.data.result;
            if (response.data.result.length > 0) {
              this.chkAgree = true;
              this.chk1 = true;
              this.chk2 = true;
              this.chk3 = true;
              this.chk4 = true;
              this.chk5 = true;
              this.chk6 = true;
              this.chk7 = true;
              this.chk8 = true;
              this.chk9 = true;
              this.chk10 = true;
              this.redirectToAppForm();
            } else {
              this.chkAgree = false;
              this.chk1 = false;
              this.chk2 = false;
              this.chk3 = false;
              this.chk4 = false;
              this.chk5 = false;
              this.chk6 = false;
              this.chk7 = false;
              this.chk8 = false;
              this.chk9 = false;
              this.chk10 = false;
            }
          },
          (error) => {}
        );
    },
    redirectToAppForm() {
      //this.$router.push({ name: "Application" });
      if (
        this.chk1 == false ||
        this.chk2 == false ||
        this.chk3 == false ||
        this.chk4 == false ||
        this.chk5 == false ||
        this.chk6 == false ||
        this.chk7 == false ||
        this.chk8 == false ||
        this.chk9 == false ||
        this.chk10 == false
      ) {
        alert(
          "Please agree you have read and understood the mentioned instructions."
        );
        return;
      }
      this.$router.push({ name: "Registration" });
    },
    redirectToSummaryForm() {
      this.$router.push({ name: "StatusSummary" });
    },
    redirectToUplodForm() {
      this.$router.push({ name: "FileDrive" });
    },
    redirectUploadDownloadStatusForm() {
      this.$router.push({ name: "UploadDownloadStatus" });
    },
    fillUserData() {
      axios
        .get(config.WEB_API_PATH + "Login/GetCurrentUser", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: {},
          crossdomain: true,
        })
        .then(
          (response) => {
            if (response.data) {
              this.userTypeID = response.data.userTypeID;
              if (this.userTypeID == 11) {
                this.getCandidateApp();
              }
              this.IsFileDriveRights= response.data.userTypeRights.filter(s=> s[1]=="FileDrive" || s[1]=="UploadDownloadStatus" ).length>0?true:false;
              //console.log(response.data);
              //console.log(this.IsFileDriveRights);
            }
          },
          (error) => {}
        );
    },
  },
  mounted() {
    this.fillUserData();
    //this.getCandidateApp();
    //this.getNotices();
    //this.getCirculars();
    /*
    let divNoticeList = document.querySelector(".divNoticeList");
    if (divNoticeList) {
      let noticeTopIncrement = 1;
      let oldnoticeTopIncrement = 0;
      divNoticeList.addEventListener("mouseenter", function() {
        oldnoticeTopIncrement = noticeTopIncrement;
        noticeTopIncrement = 0;
      });
      divNoticeList.addEventListener("mouseleave", function() {
        noticeTopIncrement = oldnoticeTopIncrement;
      });
      divNoticeList.addEventListener("mousewheel", function(e) {
        e.stopPropagation();
        if (e.deltaY > 0) {
          divNoticeList.scrollTop += 5;
        } else {
          divNoticeList.scrollTop -= 5;
        }
      });
      if (window.noticeScroll) {
        window.clearInterval(window.noticeScroll);
      }

      window.noticeScroll = window.setInterval(function() {
        divNoticeList.scrollTop += noticeTopIncrement;
        if (
          divNoticeList.scrollTop >=
          divNoticeList.scrollHeight - divNoticeList.offsetHeight
        ) {
          noticeTopIncrement = -1;
        } else if (divNoticeList.scrollTop == 0) {
          noticeTopIncrement = 1;
        }
      }, 50);
    }
    let divCircularList = document.querySelector(".divCircularList");
    if (divCircularList) {
      let circularTopIncrement = 1;
      let oldCircularTopIncrement = 0;
      divCircularList.addEventListener("mouseenter", function() {
        oldCircularTopIncrement = circularTopIncrement;
        circularTopIncrement = 0;
      });
      divCircularList.addEventListener("mouseleave", function() {
        circularTopIncrement = oldCircularTopIncrement;
      });
      divCircularList.addEventListener("mousewheel", function(e) {
        e.stopPropagation();
        if (e.deltaY > 0) {
          divCircularList.scrollTop += 5;
        } else {
          divCircularList.scrollTop -= 5;
        }
      });
      if (window.circularScroll) {
        window.clearInterval(window.circularScroll);
      }

      window.circularScroll = window.setInterval(function() {
        divCircularList.scrollTop += circularTopIncrement;
        if (
          divCircularList.scrollTop >=
          divCircularList.scrollHeight - divCircularList.offsetHeight
        ) {
          circularTopIncrement = -1;
        } else if (divCircularList.scrollTop == 0) {
          circularTopIncrement = 1;
        }
      }, 50);
    }*/
  },
};
</script>
<style scoped>
.divNoticeList {
  transition: all 500ms ease-in-out;
}
.notice {
  text-align: left;
  padding: 5px;
  position: relative;
}
.notice .entryDate {
  position: absolute;
  right: 10px;
}
.notice .noticeNo {
  font-weight: bold;
}
.notice .noticeTitle {
  font-weight: bold;
  font-size: 110%;
  display: block;
  text-transform: uppercase;
  color: blue;
}
.notice .noticeMsg {
  display: block;
}
.notice .sectionName {
  font-size: 80%;
}
.notice hr {
  margin: 10px 0 0 0;
}
.circular {
  text-align: left;
  padding: 5px;
  position: relative;
}
.circular .entryDate {
  position: absolute;
  right: 10px;
}
.circular .noticeNo {
  font-weight: bold;
}
.circular .noticeTitle {
  font-weight: bold;
  font-size: 110%;
  display: block;
  text-transform: uppercase;
  color: blue;
}
.circular .noticeMsg {
  display: block;
}
.circular .sectionName {
  font-size: 80%;
}
.circular hr {
  margin: 10px 0 0 0;
}
.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: 13px;
  margin-bottom: 6px;
  font-weight: bold;
  /* border-bottom: solid thin darkgrey; */
}
.instructionAgree {
  background: floralwhite;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: 13px;
  margin-bottom: 6px;
  font-weight: bold;
  color: #00bb0e;
}
label {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue